import { Link } from 'react-router-dom';
import { Images, DollarSign, CalendarDays, BookOpen } from 'lucide-react';

const links = [
  { icon: Images, label: 'Portfolio', path: '/portfolio', description: 'See my work' },
  { icon: DollarSign, label: 'Pricing', path: '/pricing', description: 'Session rates' },
  { icon: CalendarDays, label: 'Book Now', path: '/booking', description: 'Reserve your date' },
  { icon: BookOpen, label: 'Blog', path: '/blog', description: 'Tips & stories' },
];

export function QuickLinks() {
  return (
    <section className="relative py-8 bg-background" aria-label="Quick navigation">
      <div className="container mx-auto px-4">
        <nav className="grid grid-cols-2 md:grid-cols-4 gap-3 max-w-3xl mx-auto" aria-label="Quick links">
          {links.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className="ethereal-panel glow-hover-subtle flex min-h-[76px] items-center gap-3 p-4 transition-all duration-500 group"
            >
              <div className="flex h-11 w-11 items-center justify-center rounded-full border border-primary/20 bg-background/45">
                <link.icon className="h-5 w-5 text-primary transition-colors flex-shrink-0" />
              </div>
              <div>
                <p className="font-cinzel text-[11px] tracking-[0.22em] uppercase text-foreground">{link.label}</p>
                <p className="text-sm text-muted-foreground hidden sm:block">{link.description}</p>
              </div>
            </Link>
          ))}
        </nav>
      </div>
    </section>
  );
}
